import {
  InternalBillingSource,
  TBillableProduct,
  TBillingLineItem,
  TCheckoutSessionMetadata,
} from '@commenda/types/src/billing/types';
import { TSetNotification } from '@commenda/types/src/random';
import { Currency } from '@prisma/client';
import { BillingItemList } from './BillingItemList';
import { BillingProvider } from './BillingProvider';
import { BillingSummary } from './BillingSummary';
import { BookACallCard } from './BookACallCard';
import { Header } from './Header';

// T is the metadata type. Required to pass it, unless you do not need any metadata.
function Billing({
  initialBillingItems,
  currency,
  metadata,
  redirectionUrl,
  setNotification,
  internalBillingSource,
  getProductDescription,
  subscriptionId,
  onCheckoutOverride,
  isLoggedIn,
  companyId,
  affiliateFirmId,
  isAffiliateFirmUser,
}: {
  initialBillingItems: TBillableProduct[];
  currency: Currency;
  metadata?: TCheckoutSessionMetadata;
  redirectionUrl: string;
  setNotification: TSetNotification;
  internalBillingSource: InternalBillingSource;
  getProductDescription?: (billingItem: TBillableProduct) => React.ReactNode;
  subscriptionId?: string;
  onCheckoutOverride?: (lineItems: TBillingLineItem[]) => Promise<void>;
  isLoggedIn: boolean;
  companyId?: number;
  affiliateFirmId?: string;
  isAffiliateFirmUser?: boolean;
}) {
  return (
    <BillingProvider
      initialBillingItems={initialBillingItems}
      currency={currency}
      metadata={metadata}
      redirectionUrl={redirectionUrl}
      setNotification={setNotification}
      internalBillingSource={internalBillingSource}
      getProductDescription={getProductDescription}
      subscriptionId={subscriptionId}
      onCheckoutOverride={onCheckoutOverride}
      isLoggedIn={isLoggedIn}
      companyId={companyId}
      affiliateFirmId={affiliateFirmId}
      isAffiliateFirmUser={isAffiliateFirmUser}
    >
      <div className="w-full h-full flex flex-col gap-6">
        <Header />
        <div className="flex gap-20">
          <BillingItemList />
          <div className="flex flex-col shrink-0 w-full lg:max-w-[400px] lg:max overflow-y-auto gap-6  h-full">
            <BillingSummary />
            <BookACallCard />
          </div>
        </div>
      </div>
    </BillingProvider>
  );
}

export { Billing };
